import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export interface ImportSections {
  education: boolean;
  workExperience: boolean;
  languages: boolean;
}

/** True when the file is a PDF, by mime type or .pdf extension. */
export function isPdf(file: File | null): boolean {
  if (!file) return false;
  if (file.type === 'application/pdf') return true;
  return /\.pdf$/i.test(file.name);
}

const DOCX_MIME = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';

/** True when the file is a Word .docx, by mime type or extension. */
export function isDocx(file: File | null): boolean {
  if (!file) return false;
  if (file.type === DOCX_MIME) return true;
  return /\.docx$/i.test(file.name);
}

/** True when the file is a format the AI import accepts (PDF or Word .docx). */
export function isAiImportable(file: File | null): boolean {
  return isPdf(file) || isDocx(file);
}

/** True when the file is larger than maxMb megabytes. */
export function exceedsSizeMb(file: File | null, maxMb: number): boolean {
  if (!file) return false;
  return file.size > maxMb * 1024 * 1024;
}

/** True when at least one import section is selected. */
export function hasSelectedSection(sections: ImportSections): boolean {
  return sections.education || sections.workExperience || sections.languages;
}

/** True when an AI import should run for the current selection. */
export function willImport(file: File | null, importEnabled: boolean, sections: ImportSections): boolean {
  return isAiImportable(file) && importEnabled && hasSelectedSection(sections);
}

/** marker() key for the primary button, depending on whether an import will run. */
export function actionLabelKey(file: File | null, importEnabled: boolean, sections: ImportSections): string {
  return willImport(file, importEnabled, sections) ? marker('Save & import') : marker('Save');
}
